import {
  ButtonSolid,
  Container,
  Layout,
  ResponsiveFloraTypography,
  Text,
} from 'ui/components/primitives';

import { Flex } from '@grupoboticario/flora-react';
import { ExclamationMarkHexagonIcon } from '@grupoboticario/flora-react-icons';
import { theme } from 'ui/theme';
import useHandleClick from './useHandleClick';

const ErrorGeneric = ({ title }: { title?: string }) => {
  const { handleReloadPage } = useHandleClick();

  return (
    <>
      <Layout horizontalAlign="left">
        <Container marginBottom="sp-18" marginTop="sp-18">
          <Flex justify="center">
            <ExclamationMarkHexagonIcon
              css={{ color: theme.colors.action.nonInteractive.emphasis }}
              size="64"
            />
          </Flex>
        </Container>
      </Layout>
      <Layout>
        <Container marginBottom="sp-0" marginTop="sp-0">
          <ResponsiveFloraTypography
            as="h1"
            fontSize="subtitle"
            color={`${theme.colors.action.nonInteractive.emphasis}`}
            css={{
              textAlign: 'center',
              margin: 0,
            }}
          >
            {title || 'Tivemos um problema para carregar o conteúdo'}
          </ResponsiveFloraTypography>
        </Container>
      </Layout>
      <Layout>
        <Container marginTop="sp-6" marginBottom="sp-6" size="2/3">
          <Text color="medium-light-1" textAlign="center" variant="body-large-standard">
            Por favor, recarregue a página para tentar novamente. Se o problema persistir,
            recomendamos aguardar alguns minutos
          </Text>
        </Container>
      </Layout>
      <Layout data-testid="error" verticalAlign="center">
        <Container marginBottom="sp-6" marginTop="sp-6" size="2/3">
          <ButtonSolid onClick={handleReloadPage} stretch>
            Recarregar página
          </ButtonSolid>
        </Container>
      </Layout>
    </>
  );
};

export default ErrorGeneric;
